import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { getCloudinaryUrl } from "@swiggy-private/js-utils";
import { EMPTY_COUPON_PAGE_CONSTANTS } from "./constants";

export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    backgroundImage: `url(${getCloudinaryUrl(EMPTY_COUPON_PAGE_CONSTANTS.BACKGROUND_IMAGE)})`,
    backgroundSize: "cover",
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
}));

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const ButtonWrapper = styled.div(({ theme }) => ({
    margin: "auto",
    marginTop: `calc(2 * ${theme.spacing.large})`,
    display: "flex",
    justifyContent: "center",
    width: "70%",
    maxWidth: "300px",
}));

export const DescriptionText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
}));
